// src/components/Header/index.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Avatar, Space } from 'antd';
import { 
  HomeOutlined,
  FileTextOutlined,
  EditOutlined,
  UserOutlined
} from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
import './index.css';

function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  // 处理头像点击
  const handleAvatarClick = () => {
    navigate('/about');
  };

  // 处理退出登录
  const handleLogout = (e) => {
    e.stopPropagation();
    logout();
    navigate('/');
  };

  // 处理关于链接点击
  const handleAboutClick = () => {
    navigate('/about');
  };

  return (
    <>
      <div className="header-placeholder" />
      <header className="header">
        <div className="container">
          <div className="header-content">
            <div className="logo">
              <Link to="/">MyBlog</Link>
            </div>
            
            <nav className="nav">
              <Link to="/" className="nav-link">
                <HomeOutlined /> 首页
              </Link>
              <Link to="/archive" className="nav-link">
                <FileTextOutlined /> 归档
              </Link>
              
              {user ? (
                <>
                  <Link to="/write" className="nav-link write-btn">
                    <EditOutlined /> 写文章
                  </Link>
                  
                  {/* 用户信息区域 */}
                  <div className="user-area">
                    {/* 关于链接 */}
                    <div className="about-trigger" onClick={handleAboutClick}>
                      <UserOutlined /> 关于
                    </div>
                    
                    {/* 用户头像和用户名 */}
                    <div className="user-profile" onClick={handleAvatarClick}>
                      <Avatar 
                        size="small" 
                        className="user-avatar"
                      >
                        {user?.username?.charAt(0)?.toUpperCase() || 'U'}
                      </Avatar>
                      <span className="user-name">
                        {user.username.length > 6 ? user.username.substring(0, 6) + '...' : user.username}
                      </span>
                    </div>
                    
                    {/* 退出按钮 */}
                    <button 
                      className="logout-btn"
                      onClick={handleLogout}
                      title="退出登录"
                    >
                      退出
                    </button>
                  </div>
                </>
              ) : (
                <Link to="/auth" className="nav-link login-btn">
                  登录
                </Link>
              )}
            </nav>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;